app.controller("premiumLensSelectionFormController", [
    "$scope",
    "$filter",
    "PatientFormsAPI",
    "$stateParams",
    "ELEVEN_LABS_AI_ALCON_AGENT_1090",
    function ($scope, $filter, PatientFormsAPI, $stateParams, ELEVEN_LABS_AI_ALCON_AGENT_1090) {

        $scope.PatientFormsAPI = PatientFormsAPI;
        $scope.PatientFormsAPI.isProcessing = true;
        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');
        $scope.currentYear = new Date().getFullYear();

        $scope.allLenses = [];
        $scope.leftEyeOptions = [];
        $scope.rightEyeOptions = [];

        $scope.surgeonName = "";
        $scope.formEyeRequirement = "";

        $scope.token = $stateParams.token;
        $scope.data = {};
        $scope.dobParts = {};
        $scope.data.dob = null;

        $scope.data.selectedLensOdId = null;
        $scope.data.selectedLensOsId = null;
        $scope.data.patientComments = "";

        $scope.error = false;
        $scope.submitError = false;
        $scope.confirmed = false;

        $scope.confirmedOptionOdName = null;
        $scope.confirmedOptionOsName = null;

        $scope.ELEVEN_LABS_AI_ALCON_AGENT_1090 = ELEVEN_LABS_AI_ALCON_AGENT_1090;

        $scope.PatientFormsAPI.verifyToken("PREMIUM_LENS_SELECTION_CHOICE", $scope.token)
            .then(resp => {
                $scope.allLenses = resp.data.premium_lens_selection_choice_options || [];
                $scope.surgeonName = resp.data.user_full_name;

                $scope.leftEyeOptions = [];
                $scope.rightEyeOptions = [];

                $scope.allLenses.forEach(lens => {
                    if (lens.selected_eye === 'OS' || lens.selected_eye === 'OU') {
                        $scope.leftEyeOptions.push(lens);
                    }
                    if (lens.selected_eye === 'OD' || lens.selected_eye === 'OU') {
                        $scope.rightEyeOptions.push(lens);
                    }
                });

                const hasLeftEyeOptions = $scope.leftEyeOptions.length > 0;
                const hasRightEyeOptions = $scope.rightEyeOptions.length > 0;

                if (hasLeftEyeOptions && hasRightEyeOptions) {
                    $scope.formEyeRequirement = 'OU'; // Options are available for both eyes.
                } else if (hasRightEyeOptions) {
                    $scope.formEyeRequirement = 'OD'; // Options are available only for the right eye.
                } else if (hasLeftEyeOptions) {
                    $scope.formEyeRequirement = 'OS'; // Options are available only for the left eye.
                } else {
                    $scope.formEyeRequirement = ''; // No options available.
                }
            })
            .finally(() => {
                $scope.PatientFormsAPI.isProcessing = false;
            })
            .catch(() => {
                $scope.error = true;
            });

        $scope.$watchGroup(
            ['dobParts.year', 'dobParts.month', 'dobParts.day'],
            function (newVals) {
                const [y, m, d] = newVals;
                if (!y || !m || !d) {
                    $scope.data.dob = undefined;
                    return;
                }
                const mm = ('0' + m).slice(-2);
                const dd = ('0' + d).slice(-2);
                const iso = `${y}-${mm}-${dd}`;

                // Local-time constructor: new Date("YYYY-MM-DD") is UTC midnight, which the local
                // getters below read as the previous day west of UTC, rejecting every real date.
                const date = new Date(+y, +m - 1, +d);
                const isReal =
                    !isNaN(date) &&
                    date.getFullYear() === +y &&
                    date.getMonth() + 1 === +m &&
                    date.getDate() === +d &&
                    iso <= $scope.today;

                $scope.data.dob = isReal ? iso : undefined;
            }
        );

        $scope.getLensDisplayLabel = function (lens, eyeContext) {
            if (!lens) return '';
            let label = lens.lens_display_name + ' - $' + $filter('number')(lens.lens_price, 2);
            let isRecommendedForThisEye = false;

            if (eyeContext === 'OS' && (lens.recommended === 'OS' || lens.recommended === 'OU')) {
                isRecommendedForThisEye = true;
            } else if (eyeContext === 'OD' && (lens.recommended === 'OD' || lens.recommended === 'OU')) {
                isRecommendedForThisEye = true;
            }

            if (isRecommendedForThisEye && $scope.surgeonName) {
                label += ' (Recommended by ' + $scope.surgeonName + ')';
            }
            return label;
        };

        $scope.isOptionRecommended = function (lens, eyeContext) {
            if (!lens || !lens.recommended) {
                return false;
            }
            if (eyeContext === 'OS') {
                return lens.recommended === 'OS' || lens.recommended === 'OU';
            } else if (eyeContext === 'OD') {
                return lens.recommended === 'OD' || lens.recommended === 'OU';
            }
            return false;
        };

        $scope.isLensSelectionRecommended = function (selectedLensId, eyeContext) {
            if (!selectedLensId || !$scope.allLenses || $scope.allLenses.length === 0) {
                return false;
            }
            const lens = $scope.allLenses.find(l => l.premium_lens_id === selectedLensId);
            if (!lens) {
                return false;
            }

            if (eyeContext === 'OS') {
                return lens.recommended === 'OS' || lens.recommended === 'OU';
            } else if (eyeContext === 'OD') {
                return lens.recommended === 'OD' || lens.recommended === 'OU';
            }
            return false;
        };

        $scope.isSubmitAvailable = function () {
            const { dob, selectedLensOdId, selectedLensOsId } = $scope.data;
            if (!dob) {
                return false;
            }
            if (!$scope.formEyeRequirement) {
                return false;
            }

            switch ($scope.formEyeRequirement.toUpperCase()) {
                case "OU":
                    return !!(selectedLensOdId && selectedLensOsId);
                case "OD":
                    return !!selectedLensOdId;
                case "OS":
                    return !!selectedLensOsId;
                default:
                    return false;
            }
        };

        $scope.submit = function () {
            if (!$scope.isSubmitAvailable()) {
                return;
            }
            $scope.submitError = false;
            $scope.PatientFormsAPI.isProcessing = true;
            $scope.PatientFormsAPI.submitLensChoice(
                $scope.token,
                $scope.data.dob,
                $scope.data.selectedLensOdId,
                $scope.data.selectedLensOsId,
                $scope.data.patientComments
            ).then(() => {
                $scope.confirmed = true;
                if ($scope.data.selectedLensOdId) {
                    const odLens = $scope.allLenses.find(lens => lens.premium_lens_id === $scope.data.selectedLensOdId);
                    $scope.confirmedOptionOdName = odLens ? odLens.lens_display_name : 'N/A';
                }
                if ($scope.data.selectedLensOsId) {
                    const osLens = $scope.allLenses.find(lens => lens.premium_lens_id === $scope.data.selectedLensOsId);
                    $scope.confirmedOptionOsName = osLens ? osLens.lens_display_name : 'N/A';
                }
            }).catch(function (error) {
                console.error(`submitLensChoice error:`, error && error.status);
                $scope.submitError = true;
            }).finally(() => {
                $scope.PatientFormsAPI.isProcessing = false;
            });
        };
    }
]);